// extracted by mini-css-extract-plugin
export var contentLeft = "index-module--contentLeft--4282a";
export var contentLeftRTL = "index-module--contentLeftRTL--e7031";
export var imageLeft = "index-module--imageLeft--f55de";
export var imageLeftMobile = "index-module--imageLeftMobile--736db";
export var imageRight = "index-module--imageRight--39802";
export var imageRightMobile = "index-module--imageRightMobile--e866c";
export var scrollingContentRTL = "index-module--scrollingContentRTL--3758c";
export var scrollingRight = "index-module--scrollingRight--ff3b2";
export var scrollingStatements = "index-module--scrollingStatements--0e244";
export var statementHeading = "index-module--statementHeading--de78d";
export var statementSubHeading = "index-module--statementSubHeading--3818f";